export const SAVE_SEARCH_TYPE = 'SAVE_SEARCH_TYPE';
export const SAVE_SEARCH_PLACE = 'SAVE_SEARCH_PLACE';
export const SAVE_SEARCH_KEYWORD = 'SAVE_SEARCH_KEYWORD';
